import axios from 'axios';
import { installOfflineInterceptors } from '../offline/adapter';

// Use relative URLs in production to avoid CORS issues
// This allows the app to work on any domain (imt.hmstr.dotcloud.co.za, www.hamster4-imt.com, etc.)
const baseURL = process.env.NODE_ENV === 'production' 
  ? ''  // Empty string = relative URLs, uses same domain as frontend
  // Dev: read the port from REACT_APP_API_URL, which docker-compose.dev.yml
  // already sets to IMT's backend (8001). The hardcoded 8000 this replaces is
  // HMS's backend -- it rode in from an earlier parity port, so IMT's dev
  // frontend was posting logins at HMS. The /api suffix is stripped because
  // every caller already includes /api in its path.
  : (process.env.REACT_APP_API_URL || 'http://localhost:8001').replace(/\/api\/?$/, '');

// Export base axios instance for login/refresh endpoints
export const baseAxios = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // Enable sending cookies with requests
});

const axiosInstance = axios.create({
  baseURL: baseURL,
  withCredentials: true // Enable sending cookies with requests
});

// Add request interceptor - no longer adding Authorization header manually
// as cookies will be sent automatically
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If we get a 401 and haven't tried to refresh token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // No need to manually send the refresh token, it will be in the cookie
        await baseAxios.post('/api/token/refresh/');
        // Retry the original request
        return axios(originalRequest);
      } catch (refreshError) {
        // Clear login state
        localStorage.removeItem('isLoggedIn');
        // Redirect to login
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

/* Offline mode.
 *
 * Installed LAST on purpose. axios unshifts request interceptors, so the
 * last-registered one runs FIRST — which is what we want: an offline GET must
 * be answered from the local snapshot before anything else in the chain gets
 * involved. The response interceptor is pushed, so the 401-refresh handler
 * above still runs ahead of it; offline errors carry a 503 (never a 401) so
 * they fall straight through it untouched.
 *
 * When no pack is armed, or the browser is online, every hook here returns the
 * config unchanged — the normal request path is unaffected. */
installOfflineInterceptors(axiosInstance);

export default axiosInstance; 